// /*********************
//  * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
//  * __________________
//  *
//  *  Mobillor Technologies Pvt. Ltd.
//  *  All Rights Reserved.
//  *
//  * NOTICE:  All information contained herein is, and remains
//  * the property of Mobillor Technologies Pvt. Ltd.
//  * The intellectual and technical concepts contained
//  * herein are proprietary to Mobillor Technologies Pvt. Ltd.
//  * may be covered by Rebublic Of India and Foreign Patents,
//  * patents in process, and are protected by trade secret or copyright law.
//  * Dissemination of this information or reproduction of this material
//  * is strictly forbidden unless prior written permission is obtained
//  * from Mobillor Technologies Pvt. Ltd.
//  */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// @mui material components
import Grid from "@mui/material/Grid";

// Store
import { getSubModulesByRoleId } from "../../store";
import { TabView, TabPanel } from "primereact/tabview";

// Feature tabs

import PendingReview from "./pending-review";
import PastReview from "./reviewed/index";
import PaymentUpdate from "./payment-update";

// Cookies
import Cookies from "universal-cookie";

const cookies = new Cookies();

const Invoice = ({ getSubModulesByRoleId, getSubModulesByRoleIdReducer }) => {
  const loginDetails = cookies.get("loginDetailsForWMS");
  const jwtToken = loginDetails?.jwt;
  const roleId = loginDetails?.data?.roleId;
  const roleName = loginDetails?.data?.roleName;

  useEffect(() => {
    if (roleId && jwtToken) {
      getSubModulesByRoleId(roleId, jwtToken);
    }
  }, [roleId, jwtToken, getSubModulesByRoleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    const data = getSubModulesByRoleIdReducer?.subModulesByRoleData?.data ?? [];
    setModulesData(Array.isArray(data) ? data : []);
  }, [getSubModulesByRoleIdReducer]);

   let pastReviewAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "b64fd710-f26e-43ba-b9a8-09a133af6343"
  );

   let pendingReviewAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "565db19b-248e-453f-9766-bca7c68b9090"
  );

   let PaymentUpdateAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "4cc48115-957f-46b2-9ed7-9e1df226af56"
  );


  const tabs = [];

  if (pendingReviewAccess) {
    tabs.push({
      header: "Pending Review",
      content: <PendingReview />,
    });
  }

   if (PaymentUpdateAccess) {
    tabs.push({
      header: "Payment Update",
      content: <PaymentUpdate />,
    });
  }

  if (pastReviewAccess) {
    tabs.push({
      header: "History",
      content: <PastReview />,
    });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {tabs.length > 0 ? (
              <TabView>
                {tabs.map((tab, idx) => (
                  <TabPanel key={idx} header={tab.header}>
                    {tab.content}
                  </TabPanel>
                ))}
              </TabView>
            ) : (
              <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
                No Invoice Access
              </h4>
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Invoice);
